import React from 'react'
import { Helmet } from 'react-helmet';

// Style sheet
import '../scss/mainPage.scss';

// Page content
import AboutContent from "../../pagecontent/ts/aboutContent";

function AboutPage() {
  return (
    <div>
        <Helmet>
            <title>關於 | 專業氣象 Professional Meteorology</title>
        </Helmet>
        <div className='' id=''>
            <AboutContent />
        </div>
    </div>
  )
}

export default AboutPage;